import { PointTuple } from "leaflet";

export const findMiddlePoint = (points: PointTuple[]): PointTuple => {
  let sumX = 0;
  let sumY = 0;

  for (let i = 0; i < points.length; i++) {
    sumX += points[i][0];
    sumY += points[i][1];
  }

  return [sumX / points.length, sumY / points.length];
};
